import type { UiAppSpec, UiNavItem } from "./uiSpec";

/**
 * Simplified navigation item consumed by SidebarNav.
 */
export interface SidebarNavItem {
  id: string;
  label: string;
  href: string;
  icon?: string;
  children?: SidebarNavItem[];
  screenId?: string;
}

/**
 * Converts the UiAppSpec navigation tree into SidebarNav-friendly items.
 */
export function buildSidebarNavFromUiSpec(spec: UiAppSpec): SidebarNavItem[] {
  const mapNavItem = (item: UiNavItem): SidebarNavItem => ({
    id: item.id,
    label: item.label,
    href: item.route,
    icon: item.icon,
    screenId: item.screenId,
    children: item.children?.map(mapNavItem),
  });

  // Les sections sont manipulées par le composant Sidebar; cette fonction retourne simplement les items consolidés.
  return spec.nav.flatMap((section) => section.items.map(mapNavItem));
}
